import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            关于91暗的热门问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <span className="font-medium text-sm md:text-base text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 text-lg w-5 h-5 flex items-center justify-center shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px] pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}